import * as S from "./styles.ts";
import { AnimatePresence, motion } from "framer-motion";
import RadioBlob, { IRadioBlobProps } from "@template/components/RadioBlob";
import { ChevronUp } from "@template/icons";

export type TAccordionItem = {
  key: string | number;
  content?: any;
  label: any;
  startContent?: any;
  endContent?: any;
  disabled?: boolean;
  readOnly?: boolean;
};

interface IAccordionItemProps {
  item: TAccordionItem;
  onClick?: () => void;
  selected?: boolean;
  radio?: IRadioBlobProps | boolean;
  showArrow?: boolean;
}

const AccordionItem = ({
                         item,
                         onClick,
                         selected,
                         radio,
                         showArrow,
                       }: IAccordionItemProps) => {
  return (
    <S.AccordionItemWrapper>
      <S.AccordionItemContainer
        $selected={selected}
        data-is-selected={selected}
      >
        <S.AccordionItemTriggerContainer
          onClick={() => !item.readOnly && onClick && onClick()}
          $disabled={item.disabled}
        >
          {item.startContent}
          {radio && (
            <RadioBlob
              selected={selected}
              {...(typeof radio === "boolean" ? {} : radio)}
            />
          )}
          <S.TriggerLabel>{item.label}</S.TriggerLabel>
          {(item.endContent || showArrow) && (
            <div
              style={{
                marginLeft: "auto",
                display: "flex",
                gap: 4,
                alignItems: "center",
                height: "100%",
              }}
            >
              {item.endContent}
              {showArrow && (
                <S.ChevronContainer>
                  <ChevronUp />
                </S.ChevronContainer>
              )}
            </div>
          )}
        </S.AccordionItemTriggerContainer>
        {item.content && (
          <AnimatePresence>
            {selected && (
              <S.ContentWrapper
                as={motion.div}
                initial={{
                  height: 0,
                }}
                animate={{
                  height: "auto",
                }}
                exit={{
                  height: 0,
                }}
              >
                <S.ContentContainer>{item.content}</S.ContentContainer>
              </S.ContentWrapper>
            )}
          </AnimatePresence>
        )}
      </S.AccordionItemContainer>
    </S.AccordionItemWrapper>
  );
};

export default AccordionItem;
